<script setup>
import { onMounted, reactive, ref } from 'vue'
import useFavorites from '@/Shared/useFavorites.js'
import ListButton from './ListButton'

const props = defineProps({
  list: Array,
  title: String,
  lead: String,
  category: String,
  type: String,
})
const state = reactive({
  transition: null,
})

const onclick = ref()

onMounted(() => {
  const { updateFavoriteList } = useFavorites({ category: props.category })
  onclick.value = updateFavoriteList
  setTimeout(() => {
    state.transition = 'list-anim'
  }, '0')
})
</script>

<template>
  <transition name="list-anim">
    <div class="relative w-full flex flex-col pb-[25px]">
      <div v-if="props.title" class="link-title text-[15px] font-bold pt-[25px] pb-[15px]">{{ props.title }}</div>
      <p v-if="props.lead" class="pt-[4px] pb-[12px] leading-[1.5]">{{ props.lead }}</p>
      <div class="relative">
        <ul class="link-list max-h-full min-h-[38px]" @click="(e) => onclick(e)">
          <li v-if="!props.list.length" key="0" class="absolute top-0 py-[10px] overflow-hidden">
            <p>{{ props.title }}はありません。</p>
          </li>

          <transition-group :name="state.transition">
            <li v-for="item in props.list" :key="item[props.category + 'ID']" class="relative overflow-hidden">
              <ListButton ref="childRef" :category="props.category" :type="props.type" :item="item" />
            </li>
          </transition-group>
        </ul>
      </div>
    </div>
  </transition>
</template>
